export class Subscriber {
    public id: number;
    public customerId: number;
    public identification: string;
    public name: string;
    public email: string;
    public phone1: string;
    public phone2: string;
    public address: string;
    public department: string;
    public city: string;
    public rowIdOrder: string;
    public customer: string;
    
    constructor() {}
}